import React, { useState } from "react";

function MilpitasShowHide() {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleText = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <div className="junk-santa">
        <h3>Eco-Friendly & Responsible Disposal</h3>
        <div className="sliderline-svg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="4"
            viewBox="0 0 64 4"
            fill="none"
          >
            <path
              d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
              fill="#60BDFF"
            ></path>
          </svg>
        </div>
      </div>

      <div className="junk-santa-desc">
        <p className="resid-rmv">
          <span>Sustainable Waste Management:</span>&nbsp;We practice
          eco-friendly junk removal by responsibly disposing of hazardous waste,
          recycling scrap metal, and donating usable items. Our commitment to
          reducing environmental impact makes us the right place for
          eco-friendly junk disposal in Milpitas, CA.
        </p>
      </div>

      {isExpanded && (
        <div>
          <div className="pt-0 junk-santa-desc">
            <p>
              <span>Reliable & Local:</span>&nbsp;As a trusted full-service junk
              removal company and one of the top local junk removal companies
              (often compared with Junk King and JDog Junk Removal), our quality
              service is built on years of experience, hard work, and dedication
              to customer service.
            </p>
          </div>

          <h3>Our Milpitas Junk Removal Services</h3>
          <div className="sliderline-svg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="4"
              viewBox="0 0 64 4"
              fill="none"
            >
              <path
                d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                fill="#60BDFF"
              ></path>
            </svg>
          </div>

          <div className="junk-santa-desc">
            <h4 className="pt-3">Residential Junk Removal</h4>
            <div className="sliderline-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="4"
                viewBox="0 0 64 4"
                fill="none"
              >
                <path
                  d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                  fill="#60BDFF"
                ></path>
              </svg>
            </div>
            <ul>
              <li>
                <span>Old Furniture & Appliance Removal:</span>&nbsp;Clear out
                your old appliances, unwanted furniture, and household junk with
                our efficient removal services.
              </li>
              <li>
                <span>Mattress & Hot Tub Removal:</span>&nbsp;We handle bulky
                items and large items that require heavy lifting with ease.
              </li>
              <li>
                <span>Garage, Basement & Estate Cleanouts:</span>&nbsp;Our team
                is experienced in cleaning out single-family homes, storage
                units, and entire estates.
              </li>
              <li>
                <span>Yard Waste & Trash Removal:</span>&nbsp;From yard debris
                to general garbage removal, we offer reliable waste disposal
                services to keep your outdoor areas pristine.
              </li>
            </ul>
            <h4>Commercial Junk Removal</h4>
            <div className="sliderline-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="4"
                viewBox="0 0 64 4"
                fill="none"
              >
                <path
                  d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                  fill="#60BDFF"
                ></path>
              </svg>
            </div>
            <ul>
              <li>
                <span>Office & Retail Cleanouts:</span>&nbsp;We assist small
                businesses and commercial clients with removing outdated office
                equipment, exercise equipment, and other commercial junk.
              </li>
              <li>
                <span>Construction Debris Removal:</span>&nbsp;Our professional
                service includes the safe removal of construction debris, scrap
                metal, and demolition waste from construction sites.
              </li>

              <li>
                <span>Specialized Cleanouts:</span>&nbsp;We cater to specific
                items and provide services such as appliance removal, hazardous
                waste disposal, and even demolition services for commercial
                properties.
              </li>
            </ul>
          </div>

          <h3>Get Your Free Quote Today!</h3>
          <div className="sliderline-svg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="4"
              viewBox="0 0 64 4"
              fill="none"
            >
              <path
                d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                fill="#60BDFF"
              ></path>
            </svg>
          </div>

          <div className="junk-santa-desc">
            <p>
              For fast, professional, and eco-friendly junk removal in Milpitas,
              CA, our experienced team is here to handle the heavy lifting so
              you can enjoy peace of mind. Contact us today for a free estimate
              and discover why our customers say we do a great job every time.
            </p>
          </div>
          <div className="junk-santa-desc milpitas-list">
            <h3>Service Areas & Coverage</h3>
            <div className="sliderline-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="4"
                viewBox="0 0 64 4"
                fill="none"
              >
                <path
                  d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                  fill="#60BDFF"
                ></path>
              </svg>
            </div>
            <p className="pb-0">
              Our reliable junk removal service proudly serves the entire
              Milpitas, CA area and extends to surrounding regions, including:
            </p>
            <ul>
              <li>Milpitas, CA (City of Milpitas) & Santa Clara County</li>
              <li>San Jose, CA, Menlo Park and Mountain View</li>
              <li>
                Neighboring cities with easy access and next-day service options
              </li>
            </ul>
            <p className="pt-0">
              We are committed to delivering professional service to both
              single-family residences and commercial properties, ensuring that
              every collection day is hassle-free and meets our high standards
              of customer satisfaction.
            </p>
          </div>
        </div>
      )}

      <button className="btn btn-read" onClick={toggleText}>
        {isExpanded ? "Read Less" : "Read More"}
      </button>
    </div>
  );
}

export default MilpitasShowHide;
